import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import Images from "../ImageList";
import { motion } from "framer-motion";

const ImageTile = styled.div`
  display: block;
  max-width: 390px;
`;

const About = () => {
  return (
    <Grid
      container
      rowSpacing={2}
      columnSpacing={5}
      columns={{ xs: 1, md: 2, lg: 2, xl: 2 }}
    >
      <Grid item xs={2}>
        <Grid
          container
          rowSpacing={1}
          columnSpacing={1}
          columns={{ xs: 2, md: 4, lg: 4, xl: 4 }}
        >
          {Images.filter((element) => element.featuredIndex).sort((a, b) => (a.featuredIndex || 0) - (b.featuredIndex|| 0)).map((element, index) => {
            return (
              <Grid item xs={1} key={element.id}>
                <ImageTile>
                  <motion.div
                    key={element.id}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 0.3 + (0.3 * index) }}
                  >
                    <img
                      src={"/images/originals/" + element.id + "/390x390.jpeg"}
                      width={"100%"}
                      alt={element.title}
                    />
                  </motion.div>
                </ImageTile>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
      <Grid item xs={1}>
        <motion.div
          key={'home-left'}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.3 }}
        >
          <p>
            Hi, I'm Bhagya Perera, a self-taught wildlife artist who finds solace
            and delight in painting the wild life, primarily using acrylics on canvas.
          </p>
        
        </motion.div>
      </Grid>
      <Grid item xs={1}>
        <motion.div
          key={'home-right'}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.9 }}
        >
          <p>
            Join me on this artistic journey as we celebrate the beauty of wildlife together.
            I invite you to explore my gallery and share in
            the wonder that nature inspires.
          </p>
        
        </motion.div>
      </Grid>
    </Grid>
  );
};

export default About;
